const component = require('../component/component');

const editList = Object.assign({}, component, {
    subelements: {
        listItemsHolder: false,
        deleteWarning: false,
        searchInput: false,
        searchClear: false,
        searchIcon: false,
        searchClearIcon: false,
    },
    enableAdd: true,
    enableRemove: true,
    enableSort: false,
    minEntries: 0,
    maxEntries: 0,
    listItems: [],
    lastIndex: -1,
    listItemTemplate: '',
    sortable: false,
    searchAttributes: [],

    init: function () {
        component.init.call(this);

        this.initListActions(document);

        let listItems = document.querySelectorAll('[data-zit-list-item-for="' + this.id + '"]');

        listItems.forEach((listItemElement) => {
            let itemIndex = parseInt(listItemElement.dataset.zitItemIndex);
            if (itemIndex > this.lastIndex) {
                this.lastIndex = itemIndex;
            }
            let listItem = {
                index: itemIndex,
                element: listItemElement,
                subComponents: this.hm.app.elementSubComponents(listItemElement)
            };
            this.listItems.push(listItem);
        });

        // The listItem template only exists where add() is reachable: via add buttons
        // (enableAdd) or inited()'s minEntries padding (which runs even with add
        // disabled). A template-less tpl (editList_table) never needs it.
        this.listItemTemplate = (this.enableAdd || this.minEntries > 0) ? this.getTemplate('listItem') : '';

        if (this.searchAttributes.length && this.subelements.searchInput) {
            this.subelements.searchInput.addEventListener('input', () => {
                this.startTimer('search', () => { this.doSearch(); }, 300);
            });

            if (this.subelements.searchClear) {
                this.subelements.searchClear.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (this.subelements.searchInput.value !== '') {
                        this.subelements.searchInput.value = '';
                        this.doSearch();
                    }
                });
            }
        }
    },

    // Swap the search button between its resting magnifier and the cancel (clear) icon,
    // matching whether a query is active.
    toggleSearchClear: function (clearable) {
        if (this.subelements.searchIcon) {
            this.hm.helper.showElement(this.subelements.searchIcon, !clearable);
        }
        if (this.subelements.searchClearIcon) {
            this.hm.helper.showElement(this.subelements.searchClearIcon, clearable);
        }
        if (this.subelements.searchClear) {
            this.subelements.searchClear.title = this.hm.app.utext(clearable ? 'cancel' : 'search');
        }
    },

    // Client-side row filter over the live component values of this.searchAttributes.
    // Purely visual: rows are hidden with the theme displayNone class and still submit.
    // Deliberately not filterHide() — that would fire zitFilterShown/Hidden and trip the
    // window-visibility machinery; the searchHidden flag makes sure clearing the query
    // only re-shows rows this filter hid (never rows hidden by another mechanism).
    doSearch: function () {
        this.clearTimer('search');

        let searchQuery = this.subelements.searchInput.value.trim().toLowerCase();
        let regExSearchQuery = false;

        this.toggleSearchClear(searchQuery.length > 0);

        if (searchQuery.indexOf('*') > -1 || searchQuery.indexOf('%') > -1 || searchQuery.indexOf('+') > -1 || searchQuery.indexOf('?') > -1) {
            regExSearchQuery = searchQuery;
            regExSearchQuery = regExSearchQuery.replaceAll('%', '.*');
            regExSearchQuery = regExSearchQuery.replaceAll('*', '.*');
            regExSearchQuery = regExSearchQuery.replaceAll('+', '.+');
            regExSearchQuery = regExSearchQuery.replaceAll('?', '.{1}');
            regExSearchQuery = '^' + regExSearchQuery + '$';
            regExSearchQuery = new RegExp(regExSearchQuery);
        }

        this.listItems.forEach((listItem) => {
            let matched = true;

            if (searchQuery.length > 0) {
                matched = this.searchAttributes.some((attribute) => {
                    let searchedComponent = this.hm.app.components[this.id + '_' + attribute + '_' + listItem.index];

                    if (typeof searchedComponent === typeof undefined) {
                        return false;
                    }

                    let value = searchedComponent.getValue();

                    if (value === null || typeof value === typeof undefined) {
                        return false;
                    }

                    value = String(value).toLowerCase();

                    // wildcard queries match a whole attribute value; plain queries match a substring of it
                    return regExSearchQuery !== false ? value.match(regExSearchQuery) !== null : value.includes(searchQuery);
                });
            }

            if (matched) {
                if (listItem.searchHidden) {
                    listItem.searchHidden = false;
                    this.hm.helper.showElement(listItem.element);
                }
            } else if (!listItem.searchHidden) {
                listItem.searchHidden = true;
                this.hm.helper.hideElement(listItem.element);
            }
        });
    },

    inited: function () {
        component.inited.call(this);

        while (this.listItems.length < this.minEntries) {
            this.add(-1);
        }

        if (this.enableSort) {
            this.initSortable();
        }
    },

    initSortable: function () {
        // .draggable / .draggable-handle: selectors for the third-party Shopify
        // Draggable library — intentionally un-prefixed (vendored _draggable.scss
        // styles them + the library emits sibling draggable-* classes we can't
        // rename). See scripts/behaviors.contract.md "Documented exception".
        this.sortable = new Draggable.Sortable(this.subelements.listItemsHolder, {
            draggable: ".draggable",
            handle: ".draggable .draggable-handle",
            mirror: {
                //appendTo: selector,
                appendTo: "body",
                constrainDimensions: true
            }
        });

        this.sortable.on('sortable:start', (e) => { this.clearTimer('saveSort_' + this.id); });

        this.sortable.on("sortable:stop", (e) => {
            this.startTimer('saveSort_' + this.id, () => { this.saveSort(); }, 2500);
            //e.data.oldIndex
            //e.data.newIndex
            //e.data.dragEvent.data.source
        });
    },

    initListActions: function (parent) {
        let addButtons = parent.querySelectorAll('[data-zit-add-button-for="' + this.id + '"]');

        addButtons.forEach((addButton) => {
            addButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.add(parseInt(addButton.dataset.zitAfterIndex));
            });
        });

        let removeButtons = parent.querySelectorAll('[data-zit-remove-button-for="' + this.id + '"]');

        removeButtons.forEach((removeButton) => {
            removeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.remove(parseInt(removeButton.dataset.zitRemoveIndex));
            });
        });
    },

    add: function (afterIndex) {
        if (this.maxEntries > 0 && this.listItems.length >= this.maxEntries) {
            let maxReachedMessage = {
                type: 'info',
                text: 'maxNoOfItemsReached'
            };
            this.hm.msgs.show(maxReachedMessage);
            return false;
        }

        // -2 beginning
        // -1 end
        let afterElement = false;

        if (afterIndex >= 0) {
            for (let i = 0; i < this.listItems.length; i++) {
                if (this.listItems[i].index === afterIndex) {
                    afterElement = this.listItems[i].element;
                    break;
                }
            }

            if (afterElement === false) {
                this.hm.warn('list item with index ' + afterIndex + ' not found');
                return false;
            }
        }

        this.lastIndex++;

        let newItemHTML = this.listItemTemplate.replace(/__samplekey__/g, this.lastIndex);
        let newListItemElement = this.hm.helper.string2element(newItemHTML);
        let newListItem = {
            index: this.lastIndex,
            element: newListItemElement,
            subComponents: []
        };

        // Bridge the inserted subtree's zit-namespaced markup onto the tier's
        // framework-namespaced equivalents (zb5 mirrors data-zit-toggle="collapse"
        // and data-zit-collapse-target onto data-bs-* so Bootstrap's collapse
        // click handler picks up subsequent user toggles). The boot-time bridge
        // didn't see this subtree because it was just stamped from a template.
        this.hm.behaviors.bridgeTierAttrs(newListItemElement);

        // Apply the tier's collapse root + initial-state classes to the new
        // item's inner collapsible body region (the [data-zit-collapsible]
        // wrapper stamped from the listItem template). The boot-time
        // createInstances scan only walked `document` and never saw this
        // subtree (a <template>'s content lives in a detached fragment), so
        // without this the per-item chevron toggle would have no collapse
        // root class to act on.
        this.hm.behaviors.collapse.createInstances(newListItemElement);

        // Wrap the new list item as a collapsible region via the theme's
        // behaviour adapter (the show-on-add animation). { toggle: false }
        // suppresses the immediate auto-toggle so we control timing.
        let bsCollapse = this.hm.behaviors.collapse.create(newListItemElement, { toggle: false });

        if (afterElement !== false) {
            afterElement.after(newListItemElement);
        } else {
            if (afterIndex === -1) {
                this.subelements.listItemsHolder.append(newListItemElement);
            } else if (afterIndex === -2) {
                this.subelements.listItemsHolder.prepend(newListItemElement);
            }
        }

        newListItem.subComponents = this.hm.app.initComponents(newListItemElement);

        // Re-associate the grown subtree with the form. associateFormOwner (run at
        // init) stamps form= on every control inside this.element so a surface
        // (popupEdit container/inline) submit includes them — but it ran before this
        // row existed. initComponents above re-owned the row's *component* controls
        // via their own associateFormOwner; the row's plain structural hiddens (the
        // per-row _editListIterator / _delete fields, which are not components) were
        // not, so without this they stay owned by the ancestor mainForm and are
        // dropped from a surface submit — the row's file uploads but the iterator that
        // drives server-side row processing is missing, so the row is never saved.
        // No-op for a modal or a plain-page editList (ancestor form already matches).
        this.associateFormOwner();

        this.initListActions(newListItemElement);

        // Once the expand transition completes, drop the collapse classes so
        // the item is no longer treated as a collapsible region (it's now
        // just a static list item) and dispose the adapter. Subscribe via
        // the adapter's neutral 'shown' event name.
        bsCollapse.on('shown', (ev) => {
            // Resolve the tier's collapse root + shown tokens via the
            // behaviour contract rather than hardcoding Bootstrap literals.
            // .split(' ') because stateClass may return multiple tokens.
            newListItemElement.classList.remove(
                ...this.hm.behaviors.collapse.stateClass('root').split(' '),
                ...this.hm.behaviors.collapse.stateClass('shown').split(' ')
            );
            bsCollapse.dispose();
        });

        bsCollapse.show();

        this.listItems.push(newListItem);
    },

    remove: function (index) {
        if (this.listItems.length <= this.minEntries) {
            let maxReachedMessage = {
                type: 'info',
                text: 'minNoOfItemsReached'
            };
            this.hm.msgs.show(maxReachedMessage);
            return false;
        }

        let toRemove = false;
        let toRemovePos = false;

        for (let i = 0; i < this.listItems.length; i++) {
            if (this.listItems[i].index === index) {
                toRemove = this.listItems[i];
                toRemovePos = i;
                break;
            }
        }

        if (toRemove === false) {
            this.hm.warn('index ' + index + ' not found to remove');
            return false;
        }

        let removedItemId = 0;

        let hiddens = toRemove.element.querySelectorAll('input[type="hidden"]');

        hiddens.forEach((hidden) => {
            if (typeof this.hm.app.components[hidden.id] !== typeof undefined) {
                let hiddenComponent = this.hm.app.components[hidden.id];

                if (typeof hiddenComponent.extraAttributes.editListHiddenType !== typeof undefined && hiddenComponent.extraAttributes.editListHiddenType === 'id') {
                    removedItemId = parseInt(hiddenComponent.getValue());
                }
            }
        });

        if (removedItemId !== 0) {
            let removeComponentId = this.id + '_delete_' + index;
            let removeElement = this.hm.helper.string2element('<input type="hidden" />');
            removeElement.id = removeComponentId;
            removeElement.name = this.elementName() + '_delete[]';
            
            let removeComponent = this.hm.app.newComponent('hidden', removeComponentId, removeElement);

            removeComponent.setValue(removedItemId);

            this.subelements.listItemsHolder.prepend(removeComponent.element);

            this.hm.helper.showElement(this.subelements.deleteWarning);
        }

        toRemove.element.remove();
        this.hm.app.removeComponents(toRemove.subComponents);
        this.listItems.splice(toRemovePos, 1);
    },

    saveSort: async function () {
        this.clearTimer('saveSort_' + this.id);

        let currentListItems = document.querySelectorAll('[data-zit-list-item-for="' + this.id + '"]');

        let sorted = {};

        currentListItems.forEach((currentListItem, newIndex) => {
            let hiddens = currentListItem.querySelectorAll('input[type="hidden"]');

            let currentId = 0;
            let valueChanged = false;

            hiddens.forEach((hidden) => {
                if (typeof this.hm.app.components[hidden.id] !== typeof undefined) {
                    let hiddenComponent = this.hm.app.components[hidden.id];

                    if (typeof hiddenComponent.extraAttributes.editListHiddenType !== typeof undefined) {
                        if (hiddenComponent.extraAttributes.editListHiddenType === 'id') {
                            currentId = parseInt(hiddenComponent.getValue());
                        } else if (hiddenComponent.extraAttributes.editListHiddenType === 'sort') {
                            if (parseInt(hiddenComponent.getValue()) !== newIndex) {
                                valueChanged = true;
                            }
                            hiddenComponent.setValue(newIndex);
                        }
                    }
                }
            });

            if (currentId !== 0 && valueChanged) { //only already saved and the ones with the sort position changed are saved in the background
                sorted[currentId] = newIndex;
            }
        });

        if (Object.keys(sorted).length > 0) {
            let data = {
                configHash: this.configHash,
                componentAction: 'saveSort',
                sorted: sorted
            };

            let response = await this.hm.app.fetchJson('components', 'main', data);
            //maybe display a message that the new order was saved
        }
    }
});


module.exports = editList;